function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-0{ fill:white } .cls-1{ fill:cyan } "));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M95.78,83.24l16.73,30.06-10.7,9.87L54.4,94.31,65.75,83.84l30.07,20.69L78.39,72.18,86.15,65,117,85,98.73,53.41l11.41-10.52,25,49.58-10.7,9.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M124.81,36.07l35-17.44L165,29,142.3,40.32l4,8,22.2-11.06,5.2,10.45L151.47,58.72l4.28,8.59L178.45,56l5.17,10.39-35,17.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M175.28,13.27,188.6,9.79l10.45,40,20.75-5.42,3,11.61-34.06,8.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M221.48,28.68C220.85,12.21,232.9.63,248.89,0c13.27-.51,20.42,6.51,24.2,13.41l-11.62,6a12.92,12.92,0,0,0-12.12-7.3c-8.31.31-14.22,7.26-13.89,16S242.2,43.35,250.52,43a13,13,0,0,0,11.53-8.2L274.1,40c-3.18,7-9.86,14.7-23.13,15.2C235,55.79,222.09,45.07,221.48,28.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M314.89,6.93C330.76,10.73,340,24.6,336.17,40.4s-18.24,24-34.11,20.22-25.14-17.69-21.37-33.48S299,3.14,314.89,6.93Zm-2.83,11.83c-8.63-2.06-15.72,3.15-17.75,11.63s1.94,16.34,10.57,18.4,15.67-3.24,17.68-11.65S320.62,20.8,312.06,18.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M391.79,60.35l-30,24-5.22-3.11,6.88-37.8L345,74.36l-11.82-7,27.31-45.84,16.43,9.79L371,62.94l25.1-20.25,16.43,9.79L385.18,98.32l-11.82-7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M427.78,66.7l26.93,28.37-8.41,8L428.84,84.66l-6.44,6.12,17.08,18-8.47,8-17.08-18-7,6.61,17.46,18.39-8.41,8-26.94-28.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M472.14,145.06l-6.45-13.5,10.83-5.17,18.8,39.34-10.83,5.17-6.41-13.42-37.32,17.83-5.94-12.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M506.55,204.61c3.3,16-5.37,30.19-21.28,33.47s-29.49-6.33-32.79-22.32,5.36-30.26,21.26-33.55S503.25,188.62,506.55,204.61Zm-11.91,2.45c-1.8-8.69-9.53-12.9-18.07-11.14s-14,8.69-12.18,17.38,9.59,12.81,18.05,11.07S496.42,215.68,494.64,207.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M497.43,284.37l2.15-14.8,11.88,1.72-6.28,43.15-11.87-1.72L495.45,298,454.52,292l2-13.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M458,351.47,466.4,331l-19.84-8.13,5.22-12.73,49.37,20.23-5.21,12.73-18.44-7.55L469.1,356l18.44,7.55-5.22,12.74-49.38-20.23,5.22-12.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M471.92,393.19l-23.26,31.45-9.32-6.9,15.08-20.38-7.14-5.29L432.53,412l-9.39-6.95,14.75-19.93-7.72-5.71-15.08,20.39-9.32-6.9L429,361.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M397.33,469.71c-13.6,9-30,6.27-39-7.26s-5.12-29.72,8.48-38.74,30.08-6.32,39.06,7.21S410.94,460.69,397.33,469.71Zm-6.72-10.14c7.4-4.9,8.42-13.64,3.6-20.91s-13.27-9.73-20.67-4.82-8.3,13.67-3.53,20.87S383.28,464.44,390.61,459.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M357.53,490.92l-12.94,4.67-14-38.91L310.39,464l-4.07-11.29,33.11-11.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M308.45,507.25l-22.26,2.54c-16.69,1.91-29.83-6.73-31.71-23.19s9-27.91,25.58-29.81l22.33-2.55ZM281.5,468.7c-9.3,1.07-13.93,8.44-13,16.31.93,8.18,6.59,14,16.28,12.87l8.67-1-3.33-29.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M193.5,457.27,215,462.71l4.62-7.17,14.5,3.67L201.54,506l-16.75-4.24-6.44-56.67,14.5,3.67Zm15.15,15.8-14.51-3.67,2,22.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M153.09,490.87,118.45,472.7l5.38-10.28,22.46,11.78,4.13-7.86-22-11.52,5.42-10.34,22,11.52,9.85-18.78,12.19,6.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M106.53,431.61c-12,11.29-28.65,9.82-39.61-1.84-9.1-9.68-8.51-19.68-5.79-27.06l12.19,4.79a12.94,12.94,0,0,0,2.46,13.94c5.69,6.06,14.81,5.95,21.16,0s7-15.06,1.34-21.12A13,13,0,0,0,84.51,397l-4-12.46c7.37-2.2,17.56-2.23,26.66,7.45C118.1,403.61,118.48,420.38,106.53,431.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M43.22,399.09,36.29,387.2,72,366.37l-10.8-18.52,10.37-6,17.72,30.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M19,355.6l-4.16-13.37,29.87-9.29c6-1.87,9.39-6.43,7.18-13.54s-7.53-8.88-13.57-7L8.47,321.68,4.32,308.31l30.25-9.4c12.68-3.94,23.87.53,29,16.88s-1.66,26.48-14.18,30.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-0",
  d: "M1.17,288.22,0,258c-.4-10.55,6.28-15.85,13-16.11s11.26,3.65,12.57,8.65c.67-5.71,5.93-10.4,12.65-10.65,7.75-.3,14.67,4.64,15.07,15.12l1.19,31.18Zm19.59-27.89A4.51,4.51,0,0,0,16,255.79a4.45,4.45,0,0,0-4.38,4.89L12.08,274l9.19-.35ZM42,259c-.12-3.28-2.2-5.2-5.08-5.09a4.94,4.94,0,0,0-4.83,5.47l.53,13.83,9.91-.38Z"
})));

var SvgWelcomeCircle = function SvgWelcomeCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511.46 510.06",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome-circle.3e35ed7f.svg";
export { ForwardRef as ReactComponent };